function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M456 402l191.5-188.9c7.5-7.4 11.6-17.2 11.7-27.7.1-10.5-4-20.4-11.4-27.9-15.2-15.4-40.2-15.6-55.6-.4L400 346.8 207.8 157.1c-15.4-15.2-40.3-15-55.6.4-7.4 7.5-11.4 17.4-11.4 27.9.1 10.5 4.2 20.4 11.7 27.7L344 402 152.6 591c-15.4 15.2-15.6 40.1-.4 55.6 7.4 7.5 17.4 11.7 28 11.7 10.4 0 20.3-4 27.6-11.4L400 457.2l192.2 189.6c7.4 7.3 17.2 11.4 27.6 11.4 10.6 0 20.5-4.1 28-11.7 15.2-15.5 15-40.4-.4-55.6L456 402z"
});

function SvgCross(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: "feather",
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.48f9bd2d.svg";
export { ForwardRef as ReactComponent };